export default (props, e) => {
	let inputs = [];
	if(e.target.checked) {
		inputs = document.querySelectorAll('input[name="'+props.inputName+'"]:not(:checked)');
	} else {
		inputs = document.querySelectorAll('input[name="'+props.inputName+'"]:checked');
	}
	for(let i = 0; i< inputs.length; i++) {
		inputs[i].click();
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/checkAll.js